const initialState = {};
export default function (state = initialState, action) {
  if (action.meta && action.meta.request) {
    return Object.assign({}, state, {
      [action.meta.request.key]: action.meta.request.status
    });
  }
  return state;
}